import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from '../code-snippets/code-snippet.interface';



@Component({
    selector: 'read-adn-write-example-system',
    template: '',
    standalone: false
})
export class ReadAndWriteDatapointExampleSystem implements CodeSnippet{

    text: string = $localize`:@@script-editor.code-example.read-write-datapoints-of-systemplants:Read/Write datapoints of systemplants`

    category: string = 'examples';

    data: any;

    part = false;

    insert(): string | Promise<string> {
        return `function systemmain()

    -- get the first two system plant objects
    local plant1 = getplant("SystemPlant1")
    local plant2 = getplant("SystemPlant2")

    -- if first plant is online...
    if plant1.System.Online == 0 then

        -- set value on plant2
        plant2.User.vDataPointStr = "the other plant is offline"

    else

        -- set value on plant2
        plant2.User.vDataPointStr = "the other plant is online"

    end

end`
    }
}